import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getPlatformSession } from "./platformAuth";

export default function RequirePlatformAuth({ children }) {
  const location = useLocation();
  if (!getPlatformSession()?.token) {
    return <Navigate to="/platform-admin/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
}
